import { AlertCircle, AlertTriangle, Info } from "lucide-react";

import alertStyles from "@/components/desktop/list/CustomInfoMessage.module.scss";

import classes from "@/components/Season/Season.module.scss";

const ICON_MAP = {
	info: Info,
	warning: AlertTriangle,
	error: AlertCircle,
};

const SeasonStatusAlerts = ({ alertGroups = [] }) => {
	if (!alertGroups.length) {
		return null;
	}

	return (
		<div className={classes.alerts}>
			{alertGroups.map((alertGroup, groupIndex) => {
				const Icon = ICON_MAP[alertGroup.type] || Info;

				return (
					<div key={`${alertGroup.title}-${groupIndex}`} className={`${alertStyles.container} ${alertStyles[alertGroup.type]} ${classes.alertItem}`}>
						<div className={alertStyles.header}>
							<div className={alertStyles.iconTitle}>
								<Icon className={alertStyles.icon} />
								<span className={alertStyles.title}>{alertGroup.title}</span>
							</div>
						</div>
						<div className={alertStyles.messagesContainer}>
							{alertGroup.messages.map((message, messageIndex) => (
								<div key={`${groupIndex}-${messageIndex}`} className={alertStyles.message}>
									<span className={alertStyles.messageText}>{message}</span>
								</div>
							))}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default SeasonStatusAlerts;
